<template>
  <v-container fill-height>
    <v-row>
      <v-col class="d-flex justify-center">
        <div style="width:100%">
          <v-row>
            <v-col cols="4">
              <v-card @click="redirect(route('offerData.index'))">
                <v-img src="/img/businesscloud.jpg">
                  <v-card-title class="d-flex justify-center">
                    <h2 class="white--text" style="font-size: 42px;">
                      Preisinformationen
                    </h2>
                  </v-card-title>
                  <v-card-body class="d-flex justify-center">
                    <span class="white--text" style="font-size: 190px; font-weight:bold">
                      {{ openOfferDataCount }}
                    </span>
                  </v-card-body>
                </v-img>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card @click="redirect(route('offer.index', {tab: 'prozess'}))">
                <v-img src="/img/businesscloud.jpg">
                  <v-card-title class="d-flex justify-center">
                    <h2 class="white--text" style="font-size: 42px;">
                      Angebote
                    </h2>
                  </v-card-title>
                  <v-card-body class="d-flex justify-center">
                    <span class="white--text" style="font-size: 190px; font-weight:bold">
                      {{ inProcessCount }}
                    </span>
                  </v-card-body>
                </v-img>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card @click="redirect(route('contract.index'))">
                <v-img src="/img/businesscloud.jpg">
                  <v-card-title class="d-flex justify-center">
                    <h2 class="white--text" style="font-size: 42px;">
                      Verträge
                    </h2>
                  </v-card-title>
                  <v-card-body class="d-flex justify-center">
                    <span class="white--text" style="font-size: 190px; font-weight:bold">
                      {{ contractCount }}
                    </span>
                  </v-card-body>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { Inertia } from '@inertiajs/inertia'

export default {
   layout: (h, page) => h(Layout, [page]),

   props: {
      user: {
         type: Object,
         required: true
      },
      openOfferDataCount: {
         type: Number,
         required: true
      },
      inProcessCount: {
         type: Number,
         required: true
      },
      contractCount: {
         type: Number,
         required: true
      }
   },
   metaInfo () {
      return {
         title: this.title ? this.title : 'Willkommen'
      }
   },
   methods: {
      redirect (route) {
         Inertia.visit(route)
      }
   }

}
</script>
